import React, { useState } from 'react';
import { Layout } from 'antd';
import AppHeader from './AppHeader';
import Sidebar from './Sidebar';

const { Content, Sider } = Layout;

const MainLayout = ({ children }) => {
  const [siderVisible, setSiderVisible] = useState(false);

  return (
    <Layout>
      <AppHeader onMenuClick={() => setSiderVisible(!siderVisible)} />
      <Layout>
        <Sider 
          width={200} 
          theme="light"
          className={siderVisible ? 'ant-layout-sider-open' : ''}
          style={{ display: 'block' }}
        >
          <Sidebar />
        </Sider>
        <Content className="content">
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout; 